import { render, staticRenderFns } from "./Side-Entitlements-Group.vue?vue&type=template&id=4c64314e"
import script from "./Side-Entitlements-Group.vue?vue&type=script&lang=js"
export * from "./Side-Entitlements-Group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports